export const stringifyDefaultOptions = {
  strict: true,
  encode: true,
  arrayFormat: "bracket",
  arraySeparator: "bracket",
  sort: false,
  skipNull: true,
  skipEmptyString: true,
} as const;
